<!-- Tableau -->
<div class="container-fluid">
  <div class="text-end mt-3" *appProfilePerimeter>
    <button type="button" class="btn btn-primary" *appOnlyGroups="['ADMIN', 'STRUCTURE', 'TERRITORY', 'DIRECTION+']" (click)="openCreateModal()">
      Ajouter
    </button>
  </div>

  <div class="row mt-2">
    <div class="col px-0">
      <table class="table table-striped table-hover" aria-describedby="assessmentsTitle">
        <thead class="text-secondary bg-light">
          <tr>
            <th></th>
            <th scope="col" class="text-center" sortable="creationDateInterview" (sort)="onSort($event)">Date de l'entretien</th>
            <th scope="col" class="text-center" sortable="status" (sort)="onSort($event)">Statut</th>
            <th scope="col" class="text-center" sortable="context" (sort)="onSort($event)">Contexte</th>
            <th scope="col" class="text-center">Créé par</th>
            <th scope="col" class="text-center" sortable="updateStatusDate" (sort)="onSort($event)">Dernière mise à jour</th>
          </tr>
        </thead>
        <tbody>
          @for (assessment of assessments.items; track assessment) {
            <tr (click)="openConsultModal(assessment.id)">
              <td></td>
              <td class="text-center">{{ assessment.creationDateInterview | date }}</td>
              <td class="text-center">{{ assessmentStatusMap.get(assessment.status) }}</td>
              <td class="text-center">{{ assessmentContextMap.get(assessment.context) }}</td>
              <td class="text-center">{{ assessment.creatorUser.name }}</td>
              <td class="text-center">{{ assessment.updateStatusDate | date }}</td>
            </tr>
          }
        </tbody>
      </table>
    </div>
    @if (!assessments.items.length) {
      <p>Le bénéficiaire n'a aucun diagnostic.</p>
    }
  </div>
  <div class="d-flex justify-content-between">
    <ngb-pagination
      [collectionSize]="assessments.totalItems"
      [page]="assessments.options.page"
      [pageSize]="assessments.options.limit"
      (pageChange)="changePage($event)"
      >
    </ngb-pagination>
    <select class="w-auto form-select" [ngModel]="assessments.options.limit" (change)="changeLimit($event)">
      <option [value]="10">10 éléments par page</option>
      <option [value]="25">25 éléments par page</option>
      <option [value]="50">50 éléments par page</option>
      <option [value]="100">100 éléments par page</option>
    </select>
  </div>
</div>
